import { createStyles, Grid, makeStyles, Paper, Theme, Dialog, DialogContent, Box } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import PaymentMethodVerification from '../../components/PaymentMethodVerification';
import PaymentReceived from '../../components/PaymentReceived';
import PaymentInfoNotFound from '../../components/PaymentInfoNotFound';
import MissingRefundPolicy from '../../components/MissingRefundPolicy';
import PayPaymentRequest from '../../components/PayPaymentRequest';
import { fetchViewerUserByEmail } from '../app/AppActions';
import {
  fetchPaymentError,
  fetchHasSearchString,
  fetchVerificationVisible,
  selectVerificationVisible,
  fetchVerifyInfoVisible,
  selectVerifyInfoVisible,
  selectNetworkBusy,
  selectDisplayRefundPolicy,
  fetchDeletePayerPaymentMethodStatus,
  selectDeletePayerPaymentMethodStatus,
  selectPaymentRequestInfo,
  fetchDisplayRefundPolicy,
  selectPaymentError,
  selectHasSearchString,
  fetchVerifyPaymentMethodStatus,
  selectVerifyPaymentMethodStatus,
  fetchUrlToken,
  fetchConfirmDeleteVisible,
  selectConfirmDeleteVisible,
  fetchRequirePaymentMethodVisible,
  selectRequirePaymentMethodVisible,
  clearPaymentRequestInfo,
  selectPaymentAddVisible,
  fetchPaymentAddVisible,
  selectDefaultPaymentMethod,
  selectSelectedPaymentMethod,
  fetchSelectedPaymentMethod,
  fetchPaymentMethodForEdit,
  fetchPayerProfile,
  selectPaymentMethodForEdit,
  selectPaymentMethods,
  selectDeletePaymentMethodError,
  fetchBillingAddresses,
  addBillingAddress,
  selectBillingAddresses,
  selectPaymentMethodError,
  fetchPaymentMethodError,
  selectPaymentMethodAdded,
  selectPayerTransactionSummaryByMerchant,
  fetchDeletePaymentMethodError,
  fetchSnackBarOpen,
  fetchSnackBarAlert,
  fetchSelectedMerchant,
  selectSelectedMerchant,
  fetchRequestTabValue,
  fetchSelectedMerchantName,
  selectPaymentRequestInfoList,
  fetchPaymentRequestInfoList,
  fetchConsolidatedOrPartialCancelClicked,
  selectSelectedMerchantInfo,
  fetchSelectedMerchantInfo,
  selectCreditMemoBalance,
  selectCreditMemoBalanceError,
  selectLoadingCreditMemoBalance,
  selectOpenCreditMemoConnection,
  selectOpenCreditMemos,
  selectOpenCreditMemosError,
  clearOpenCreditMemoConnection,
  clearOpenCreditMemos,
  selectCreditMemoDetailsOpen,
  fetchCreditMemoDetailsOpen,
  selectCreditMemoHistoryConnection,
  selectCreditMemoHistory,
  selectCreditMemoHistoryError,
  clearCreditMemoHistory,
  clearCreditMemoHistoryConnection,
  selectLoadingPaymentMethods,
  selectDeletingPaymentMethod,
  selectSortedPaymentMethods,
} from './MultipleMethodsHomeSlice';
import {
  fetchPaymentRequestInfo,
  verifyBankPaymentMethod,
  deletePayerPaymentMethod,
  createPayerPaymentMethod,
  setDefaultPaymentMethod,
  createPayerPayment,
  getPayerTransactionSummaryByMerchant,
  fetchRecentTransactions,
  fetchPaymentsDue,
  createPayerConsolidatedOrPartialPayment,
  fetchCreditMemoBalance,
  fetchOpenCreditMemos,
  fetchCreditMemosHistory,
} from './MultipleMethodsHomeActions';
import {
  PaymentRequestStatus,
  MutationStatusCode,
  Person,
  CurrencyType,
  UpsertPersonStatus,
  PayerPaymentMethod,
  PaymentMethodType,
  PaymentMethodHolderInput,
  PaymentMethodStatus,
  PaymentMethodHolder,
  AcceptedPaymentMethod,
  PendingReasonCode,
  PaymentRequestInfo,
  PaymentStatus,
  CreatePaymentStatus,
  MerchantInfo,
  PaymentRequestAllocationInput,
} from '../../gql-types.generated';
import PaymentProcessing from '../../components/PaymentProcessing';
import ConfirmDelete from '../../components/ConfirmDelete';
import PaymentUnknown from '../../components/PaymentUnknown';
import {
  fetchPayerAccountStatus,
  selectUpsertingPayerBankAccount,
  selectMenuVisible,
  fetchMenuVisible,
  fetchShowMerchantSort,
} from '../app/AppSlice';
import PaymentMethodAdd from '../../components/PaymentMethodAdd';
import { getIsRequestPayable } from '../../util/Util';
import PaymentMethods from '../../components/PaymentMethods';
import MapCardBrandToAcceptedPaymentMethod from '../../util/MapCardBrandToAcceptedPaymentMethod';
import { Alert } from '@material-ui/lab';
import LoadingMask from '../../components/LoadingMask';
import SettingsMenu from '../../components/SettingsMenu';
import MerchantRequestsView from '../merchantRequestsView/MerchantRequestsView';
import MerchantSummaryView from '../merchantSummaryView/MerchantSummaryView';
import { DateTime } from 'luxon';
import CreditMemosDetails from '../../components/CreditMemosDetails';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    padding: {
      padding: theme.spacing(1.5, 2, 0, 2),
    },
    paper: {
      marginTop: theme.spacing(2),
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    mobileManageAccount: {
      marginBottom: theme.spacing(2),
    },
    icon: {
      fontSize: '1.5rem',
      color: theme.palette.text.secondary,
    },
    snackBar: {
      minWidth: '100%',
      justifyContent: 'center',
    },
    noneDisplay: {
      display: 'none',
    },
    homeView: {
      display: 'flex',
      marginRight: theme.spacing(2),
    },
    mobileHomeView: {
      display: 'flex',
    },
    transition: {
      transition: theme.transitions.create('all', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      display: 'flex',
      justifyContent: 'center',
    },
  }),
);

export interface PaymentMethodStatusData {
  error: Error;
  tokenError: Error;
  statusSuccess: boolean;
  invalidRoutingNumber: boolean;
  invalidAccountNumber: boolean;
}

interface MultipleMethodsHomeProps {
  payerAccountStatus?: UpsertPersonStatus;
  userEmail?: string;
  viewerUser?: Person;
  merchantSortAnchorEl: HTMLDivElement | null;
}

const MultipleMethodsHome: React.FC<MultipleMethodsHomeProps> = props => {
  const { viewerUser, userEmail, payerAccountStatus, merchantSortAnchorEl } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const paymentError = useSelector(selectPaymentError);
  const paymentRequestInfo = useSelector(selectPaymentRequestInfo);
  const hasSearchString = useSelector(selectHasSearchString);
  const displayRefundPolicy = useSelector(selectDisplayRefundPolicy);
  const deletePayerMethodStatus = useSelector(selectDeletePayerPaymentMethodStatus);
  const confirmDeleteVisible = useSelector(selectConfirmDeleteVisible);
  const requirePaymentMethodVisible = useSelector(selectRequirePaymentMethodVisible);
  const verificationVisible = useSelector(selectVerificationVisible);
  const verifyInfoVisible = useSelector(selectVerifyInfoVisible);
  const paymentAddVisible = useSelector(selectPaymentAddVisible);
  const verifyPaymentMethodStatus = useSelector(selectVerifyPaymentMethodStatus);
  const upsertingPayerBankAccount = useSelector(selectUpsertingPayerBankAccount);
  const paymentMethods = useSelector(selectPaymentMethods);
  const sortedPaymentMethods = useSelector(selectSortedPaymentMethods);
  const paymentMethodError = useSelector(selectPaymentMethodError);
  const paymentMethodAdded = useSelector(selectPaymentMethodAdded);
  const creditMemoBalance = useSelector(selectCreditMemoBalance);
  const creditMemoBalanceError = useSelector(selectCreditMemoBalanceError);
  const loadingCreditMemoBalance = useSelector(selectLoadingCreditMemoBalance);
  const openCreditMemoConnection = useSelector(selectOpenCreditMemoConnection);
  const openCreditMemos = useSelector(selectOpenCreditMemos);
  const openCreditMemosError = useSelector(selectOpenCreditMemosError);
  const creditMemoDetailsOpen = useSelector(selectCreditMemoDetailsOpen);
  const creditMemoHistoryConnection = useSelector(selectCreditMemoHistoryConnection);
  const creditMemoHistory = useSelector(selectCreditMemoHistory);
  const creditMemoHistoryError = useSelector(selectCreditMemoHistoryError);
  // This will be the default selected billing and payment method info.
  const defaultPaymentMethod = useSelector(selectDefaultPaymentMethod);
  const selectedPaymentMethod = useSelector(selectSelectedPaymentMethod);
  const deletePaymentMethodError = useSelector(selectDeletePaymentMethodError);
  const methodForEdit = useSelector(selectPaymentMethodForEdit);
  const networkBusy = useSelector(selectNetworkBusy);
  const billingAddresses = useSelector(selectBillingAddresses);
  const payerTransactionSummaryByMerchant = useSelector(selectPayerTransactionSummaryByMerchant);
  const settingsMenuVisible = useSelector(selectMenuVisible);
  const selectedMerchant = useSelector(selectSelectedMerchant);
  const selectedMerchantInfo = useSelector(selectSelectedMerchantInfo);
  const paymentRequestInfoList = useSelector(selectPaymentRequestInfoList);
  const loadingPaymentMethods = useSelector(selectLoadingPaymentMethods);
  const deletingPaymentMethod = useSelector(selectDeletingPaymentMethod);
  const isMobileSize = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const [sendingPayment, setSendingPayment] = useState<boolean>(false);
  const [isAddCardClicked, setIsAddCardClicked] = useState<boolean>(false);
  const [isAddBankClicked, setIsAddBankClicked] = useState<boolean>(false);
  const [isIFrameVisible, setIsIFrameVisible] = useState<boolean>(false);
  // eCheckAllowed is in control of the state of allowing a bank account being added/used for payment.
  // If no payment request info, allow eCheck for managing the account.
  const [eCheckAllowed, setECheckAllowed] = useState(
    (!!paymentRequestInfo?.supportedPaymentMethods &&
      paymentRequestInfo?.supportedPaymentMethods.includes(PaymentMethodType.PaymentBankUs)) ||
      (!!selectedMerchantInfo?.supportedPaymentMethods &&
        selectedMerchantInfo?.supportedPaymentMethods.includes(PaymentMethodType.PaymentBankUs)),
  );
  const [cardAllowed, setCardAllowed] = useState(
    (!!paymentRequestInfo?.supportedPaymentMethods &&
      paymentRequestInfo?.supportedPaymentMethods.includes(PaymentMethodType.CreditCard)) ||
      (!!selectedMerchantInfo?.supportedPaymentMethods &&
        selectedMerchantInfo?.supportedPaymentMethods.includes(PaymentMethodType.CreditCard)),
  );
  const [bankForVerification, setBankForVerification] = useState<PayerPaymentMethod | undefined>();
  const [addPaymentMethodType, setAddPaymentMethodType] = useState<PaymentMethodType | undefined>();
  const [paymentMethodAddStep, setPaymentMethodAddStep] = useState<number>(0);
  const [useCreditMemo, setUseCreditMemo] = useState<boolean>(false);
  const matchesXsDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));

  // Page size until infinite scroller loads more
  const pageSize = 15;

  useEffect(() => {
    if (settingsMenuVisible === false) {
      if (paymentMethodError) dispatch(fetchPaymentMethodError());
      if (deletePaymentMethodError) dispatch(fetchDeletePaymentMethodError());
    }
  }, [settingsMenuVisible]);

  useEffect(() => {
    if (paymentRequestInfo && paymentRequestInfo.supportedPaymentMethods && paymentRequestInfo.supportedPaymentMethods.length > 0) {
      setECheckAllowed(paymentRequestInfo.supportedPaymentMethods.includes(PaymentMethodType.PaymentBankUs));
      setCardAllowed(paymentRequestInfo.supportedPaymentMethods.includes(PaymentMethodType.CreditCard));
    }
    if (
      selectedMerchantInfo &&
      selectedMerchantInfo.supportedPaymentMethods &&
      selectedMerchantInfo.supportedPaymentMethods.length > 0
    ) {
      setECheckAllowed(selectedMerchantInfo.supportedPaymentMethods.includes(PaymentMethodType.PaymentBankUs));
      setCardAllowed(selectedMerchantInfo.supportedPaymentMethods.includes(PaymentMethodType.CreditCard));
    }
  }, [paymentRequestInfo, selectedMerchantInfo]);

  // detects changes to url and acts accordingly
  useEffect(() => {
    if (location.search === '') {
      dispatch(fetchHasSearchString(false));
      dispatch(clearPaymentRequestInfo());
    } else {
      dispatch(fetchHasSearchString(true));
      dispatch(fetchUrlToken(window.location.search.substring(1)));
      dispatch(fetchPaymentRequestInfo(window.location.search.substring(1)));
    }
  }, [location]);

  useEffect(() => {
    if (userEmail && payerAccountStatus?.code === MutationStatusCode.Success) {
      dispatch(fetchViewerUserByEmail(userEmail));
      dispatch(fetchPayerAccountStatus(undefined));
    }
  }, [payerAccountStatus]);

  useEffect(() => {
    if (userEmail && deletePayerMethodStatus?.code === MutationStatusCode.Success) {
      dispatch(fetchViewerUserByEmail(userEmail));
      dispatch(fetchDeletePayerPaymentMethodStatus(undefined));
    }
  }, [deletePayerMethodStatus]);

  useEffect(() => {
    if (userEmail && verifyPaymentMethodStatus?.code === MutationStatusCode.Success) {
      dispatch(fetchViewerUserByEmail(userEmail));
      dispatch(fetchVerifyPaymentMethodStatus(undefined));
    }
  }, [verifyPaymentMethodStatus]);

  //only show the merchant sort button while in the merchant summary screen
  useEffect(() => {
    if (!selectedMerchant && payerTransactionSummaryByMerchant) {
      dispatch(fetchShowMerchantSort(true));
    } else {
      dispatch(fetchShowMerchantSort(false));
    }
  }, [selectedMerchant, payerTransactionSummaryByMerchant]);

  const toggleVerifyInfo = () => {
    dispatch(fetchVerifyInfoVisible(!verifyInfoVisible));
  };

  const getPaymentBank = () => {
    return paymentMethods?.find(method => {
      //This only works if there is maximum one bank account
      return method.paymentMethod?.type === PaymentMethodType.PaymentBankUs;
    });
  };

  useEffect(() => {
    if (viewerUser) {
      if (viewerUser?.payerProfile) {
        dispatch(fetchPayerProfile(viewerUser.payerProfile));
      }
      const paymentBank = getPaymentBank();
      if (upsertingPayerBankAccount && paymentBank && paymentBank.paymentMethod?.status !== PaymentMethodStatus.ProcessingError) {
        // show verify on this upsert of bank account info if the account is not in an error state.
        toggleVerifyInfo();
      }
    }
  }, [viewerUser]);

  const setSelectedMerchant = (merchant: string | undefined) => {
    dispatch(fetchSelectedMerchant(merchant));
  };

  //If there is only one merchant, go directly to that merchant instead of showing the merchant cards/tiles
  useEffect(() => {
    const summary = payerTransactionSummaryByMerchant;
    if (summary && summary.merchantSummary && summary.merchantSummary.length === 1) {
      setSelectedMerchant(summary.merchantSummary[0].merchantInfo?.owner?.tenantId);
      if (!paymentRequestInfo) {
        history.push('/payments');
      }
    }
  }, [payerTransactionSummaryByMerchant]);

  useEffect(() => {
    const merchantInfo = payerTransactionSummaryByMerchant?.merchantSummary.find(merchant => {
      return selectedMerchant === merchant.merchantInfo?.owner?.tenantId;
    })?.merchantInfo;
    dispatch(fetchSelectedMerchantInfo(merchantInfo as MerchantInfo));
  }, [selectedMerchant]);

  const requestPayable = getIsRequestPayable(paymentRequestInfo);

  useEffect(() => {
    dispatch(getPayerTransactionSummaryByMerchant());
  }, []);

  const setDefaultMethod = (paymentMethod: PayerPaymentMethod) => {
    if (paymentMethod && viewerUser && userEmail) {
      dispatch(setDefaultPaymentMethod(paymentMethod, viewerUser.id, userEmail));
    }
  };

  useEffect(() => {
    if (viewerUser && selectedMerchant) {
      const name = payerTransactionSummaryByMerchant?.merchantSummary.find(merchant => {
        return selectedMerchant === merchant.merchantInfo?.owner?.tenantId;
      })?.merchantInfo?.name;
      dispatch(fetchSelectedMerchantName(name as string));
      dispatch(fetchRecentTransactions(undefined, pageSize, selectedMerchant));
      dispatch(fetchPaymentsDue(selectedMerchant));
      dispatch(fetchCreditMemoBalance(selectedMerchant));
    }
  }, [selectedMerchant]);

  useEffect(() => {
    //Stores a list of unique billing addresses in state.
    if (paymentMethods) {
      const billingAddresses: PaymentMethodHolder[] = [];
      paymentMethods.forEach(method => {
        const card = method.paymentMethod?.creditCard?.cardHolder;
        const bank = method.paymentMethod?.paymentBank?.accountHolder;

        const uniqueCard = !billingAddresses.find(address => {
          return (
            card &&
            address.address?.line1 &&
            address.address?.postalCode &&
            address?.email &&
            address?.phone?.number &&
            address.address.line1.localeCompare(card.address?.line1 || '') === 0 &&
            address.address.postalCode.localeCompare(card.address?.postalCode || '') === 0 &&
            address.email.localeCompare(card?.email || '') === 0 &&
            address.phone.number.localeCompare(card.phone?.number || '') === 0
          );
        });

        const uniqueBank = !billingAddresses.find(address => {
          return (
            bank &&
            address.address?.line1 &&
            address.address?.postalCode &&
            address?.email &&
            address?.phone?.number &&
            address.address.line1.localeCompare(bank.address?.line1 || '') === 0 &&
            address.address.postalCode.localeCompare(bank.address?.postalCode || '') === 0 &&
            address.email.localeCompare(bank?.email || '') === 0 &&
            address.phone.number.localeCompare(bank.phone?.number || '') === 0
          );
        });

        if (card && uniqueCard) {
          billingAddresses.push(card);
        }
        if (bank && uniqueBank) {
          billingAddresses.push(bank);
        }
      });

      const paymentMethodDefault = paymentMethods.find(item => item.isDefault === true);
      if (paymentMethodDefault && !defaultPaymentMethod) setDefaultMethod(paymentMethodDefault);

      dispatch(fetchBillingAddresses(billingAddresses));
    }
  }, [paymentMethods]);

  // Return immediately if condition allows.
  if (networkBusy && !sendingPayment) {
    return <Paper className={classes.paper}>Loading!</Paper>;
  }
  const toggleAddingPayments = () => {
    dispatch(fetchPaymentMethodError(undefined));
    dispatch(fetchPaymentAddVisible(!paymentAddVisible));
    if (requirePaymentMethodVisible === true) {
      dispatch(fetchRequirePaymentMethodVisible(false));
    }
  };

  const toggleConfirmDelete = () => {
    dispatch(fetchConfirmDeleteVisible(!confirmDeleteVisible));
  };
  const toggleVerification = () => {
    dispatch(fetchVerificationVisible(!verificationVisible));
  };

  const getAlert = (status: PaymentStatus, pendingReason: PendingReasonCode | undefined) => {
    const paymentMethod = selectedPaymentMethod || defaultPaymentMethod;
    const email =
      paymentMethod?.paymentMethod?.creditCard?.cardHolder?.email || paymentMethod?.paymentMethod?.paymentBank?.accountHolder?.email;
    if (paymentRequestInfo && pendingReason === PendingReasonCode.BankVerification) {
      dispatch(
        fetchSnackBarAlert(
          <Alert
            className={classes.snackBar}
            severity="warning"
          >{`Your payment has been sent, but is awaiting bank account verification.`}</Alert>,
        ),
      );
    } else if (
      paymentRequestInfo &&
      (status === PaymentStatus.Completed ||
        pendingReason === PendingReasonCode.Processing ||
        pendingReason === PendingReasonCode.EcheckSubmission)
    ) {
      dispatch(
        fetchSnackBarAlert(
          <Alert
            className={classes.snackBar}
            severity="success"
          >{`Your payment to ${paymentRequestInfo.merchantName} has been successfully received. You will receive an email receipt at ${email}.`}</Alert>,
        ),
      );
    } else {
      dispatch(
        fetchSnackBarAlert(
          <Alert
            className={classes.snackBar}
            severity="warning"
          >{`Your payment is pending. You will receive an email receipt at ${email}.`}</Alert>,
        ),
      );
    }
  };

  const handlePaymentSent = (createPaymentStatus: CreatePaymentStatus | null, merchant?: string) => {
    const payment = createPaymentStatus?.payment;
    // Proceed if a payment was successful
    if (payment && payment.status !== PaymentStatus.Canceled && payment.status !== PaymentStatus.Failed) {
      // Takes the user back to the selected merchant
      setSelectedMerchant(undefined);
      if (merchant) {
        setSelectedMerchant(merchant);
      }
      history.push('/payments');
      dispatch(fetchHasSearchString(false));
      dispatch(fetchUrlToken(''));
      // Generates the proper alert to show in the toast
      getAlert(payment.status, payment.pendingReasonCode as PendingReasonCode);
      dispatch(fetchSnackBarOpen(true));
      // Sets the table to show the recent payments list for the selected merchant
      dispatch(fetchRequestTabValue(1));
    }
    setSendingPayment(false);
    if (
      selectedMerchant &&
      selectedMerchantInfo?.owner?.tenantId === selectedMerchant &&
      selectedMerchantInfo.features?.creditMemos.enabled
    ) {
      dispatch(fetchCreditMemoBalance(selectedMerchant));
    }
  };

  const getPaymentRequestInfoAmount = () => {
    const discountEndDate = DateTime.fromISO(paymentRequestInfo?.discountEndDate);
    const discountEndValid = discountEndDate.isValid && discountEndDate > DateTime.utc();
    const discountAmount = (discountEndValid && paymentRequestInfo?.discountAmount) || 0;

    return paymentRequestInfo?.totalDue ? paymentRequestInfo?.totalDue - discountAmount : 0;
  };

  const getSubtotalAmountToPay = () => {
    let amount = 0;
    if (paymentRequestInfoList) {
      paymentRequestInfoList.forEach(p => {
        if (p.amount) {
          amount += p.amount;
        }
      });
    }
    return amount;
  };

  const getCreditMemoAmountToPay = () => {
    if (!creditMemoBalanceError && useCreditMemo && creditMemoBalance > 0 && selectedMerchantInfo?.features?.creditMemos.enabled) {
      const subTotal = getSubtotalAmountToPay();
      const creditAmount = creditMemoBalance > subTotal ? subTotal : creditMemoBalance;
      return creditAmount;
    }
    return 0;
  };

  const getTotalAmountToPay = () => {
    const subTotalAmount = getSubtotalAmountToPay();
    const creditAmount = getCreditMemoAmountToPay();

    return subTotalAmount - creditAmount;
  };

  const finalizePaymentSubmit = () => {
    const paymentMethod = selectedPaymentMethod || defaultPaymentMethod;
    if (
      paymentRequestInfo &&
      paymentMethod &&
      paymentMethod.paymentMethod &&
      paymentMethod.paymentMethod.creditCard &&
      paymentMethod.paymentMethod.creditCard.cardHolder &&
      paymentMethod.paymentMethod.creditCard.cardHolder.address &&
      paymentMethod.paymentMethod.creditCard.cardHolder.address.postalCode &&
      paymentMethod.paymentMethod.creditCard.cardHolder.address.country &&
      paymentMethod.paymentMethod.creditCard.cardHolder.phone &&
      paymentMethod.paymentMethod.creditCard.cardHolder.phone.countryCode &&
      paymentMethod.paymentMethod.creditCard.cardHolder.phone.number
    ) {
      dispatch(
        createPayerPayment(
          paymentMethod.paymentMethod.id,
          paymentRequestInfo,
          true,
          {
            // honestly why are there two nearly-identical types for address and phone
            address: {
              line1: paymentMethod.paymentMethod.creditCard.cardHolder.address.line1,
              line2: paymentMethod.paymentMethod.creditCard.cardHolder.address.line2,
              city: paymentMethod.paymentMethod.creditCard.cardHolder.address.city,
              region: paymentMethod.paymentMethod.creditCard.cardHolder.address.region,
              postalCode: paymentMethod.paymentMethod.creditCard.cardHolder.address.postalCode,
              country: paymentMethod.paymentMethod.creditCard.cardHolder.address.country,
            },
            phone: {
              countryCode: paymentMethod.paymentMethod.creditCard.cardHolder.phone.countryCode,
              number: paymentMethod.paymentMethod.creditCard.cardHolder.phone.number,
            },
            lineItems: [],
          },
          //whether credit memo balance is applied or not
          !creditMemoBalanceError &&
            useCreditMemo &&
            creditMemoBalance > 0 &&
            (selectedMerchantInfo?.features?.creditMemos.enabled as boolean),
          creditMemoBalance,
          handlePaymentSent,
        ),
      );
      setSendingPayment(true);
    } else if (
      paymentRequestInfo &&
      paymentMethod &&
      paymentMethod.paymentMethod &&
      paymentMethod.paymentMethod.paymentBank &&
      paymentMethod.paymentMethod.paymentBank.accountHolder &&
      paymentMethod.paymentMethod.paymentBank.accountHolder.address &&
      paymentMethod.paymentMethod.paymentBank.accountHolder.address.postalCode &&
      paymentMethod.paymentMethod.paymentBank.accountHolder.address.country &&
      paymentMethod.paymentMethod.paymentBank.accountHolder.phone &&
      paymentMethod.paymentMethod.paymentBank.accountHolder.phone.countryCode &&
      paymentMethod.paymentMethod.paymentBank.accountHolder.phone.number
    ) {
      dispatch(
        createPayerPayment(
          paymentMethod.paymentMethod.id,
          paymentRequestInfo,
          true,
          {
            // honestly why are there two nearly-identical types for address and phone
            address: {
              line1: paymentMethod.paymentMethod.paymentBank.accountHolder.address.line1,
              line2: paymentMethod.paymentMethod.paymentBank.accountHolder.address.line2,
              city: paymentMethod.paymentMethod.paymentBank.accountHolder.address.city,
              region: paymentMethod.paymentMethod.paymentBank.accountHolder.address.region,
              postalCode: paymentMethod.paymentMethod.paymentBank.accountHolder.address.postalCode,
              country: paymentMethod.paymentMethod.paymentBank.accountHolder.address.country,
            },
            phone: {
              countryCode: paymentMethod.paymentMethod.paymentBank.accountHolder.phone.countryCode,
              number: paymentMethod.paymentMethod.paymentBank.accountHolder.phone.number,
            },
            lineItems: [],
          },
          //whether credit memo balance is applied or not
          !creditMemoBalanceError &&
            useCreditMemo &&
            creditMemoBalance > 0 &&
            (selectedMerchantInfo?.features?.creditMemos.enabled as boolean),
          creditMemoBalance,
          handlePaymentSent,
        ),
      );
      setSendingPayment(true);
    }

    if (paymentRequestInfoList) {
      const paymentRequestAllocation: PaymentRequestAllocationInput[] = [];
      paymentRequestInfoList.forEach(p => {
        const { amount } = p;
        const paymentRequestId = p.paymentDue.paymentRequest?.id;
        if (amount && paymentRequestId) {
          paymentRequestAllocation.push({
            amount,
            paymentRequestId,
          });
        }
      });

      if (
        paymentRequestInfoList &&
        selectedMerchant &&
        selectedMerchantInfo?.defaultCurrency &&
        paymentMethod &&
        paymentMethod.paymentMethod &&
        paymentMethod.paymentMethod.creditCard &&
        paymentMethod.paymentMethod.creditCard.cardHolder &&
        paymentMethod.paymentMethod.creditCard.cardHolder.address &&
        paymentMethod.paymentMethod.creditCard.cardHolder.address.postalCode &&
        paymentMethod.paymentMethod.creditCard.cardHolder.address.country &&
        paymentMethod.paymentMethod.creditCard.cardHolder.phone &&
        paymentMethod.paymentMethod.creditCard.cardHolder.phone.countryCode &&
        paymentMethod.paymentMethod.creditCard.cardHolder.phone.number
      ) {
        dispatch(
          createPayerConsolidatedOrPartialPayment(
            getTotalAmountToPay(),
            paymentMethod.paymentMethod.id,
            selectedMerchant,
            selectedMerchantInfo.defaultCurrency,
            true,
            {
              // honestly why are there two nearly-identical types for address and phone
              address: {
                line1: paymentMethod.paymentMethod.creditCard.cardHolder.address.line1,
                line2: paymentMethod.paymentMethod.creditCard.cardHolder.address.line2,
                city: paymentMethod.paymentMethod.creditCard.cardHolder.address.city,
                region: paymentMethod.paymentMethod.creditCard.cardHolder.address.region,
                postalCode: paymentMethod.paymentMethod.creditCard.cardHolder.address.postalCode,
                country: paymentMethod.paymentMethod.creditCard.cardHolder.address.country,
              },
              phone: {
                countryCode: paymentMethod.paymentMethod.creditCard.cardHolder.phone.countryCode,
                number: paymentMethod.paymentMethod.creditCard.cardHolder.phone.number,
              },
              lineItems: [],
            },
            paymentRequestAllocation,
            paymentRequestInfoList,
            getCreditMemoAmountToPay(),
            handlePaymentSent,
          ),
        );
        setSendingPayment(true);
      } else if (
        paymentRequestInfoList &&
        selectedMerchant &&
        selectedMerchantInfo?.defaultCurrency &&
        paymentMethod &&
        paymentMethod.paymentMethod &&
        paymentMethod.paymentMethod.paymentBank &&
        paymentMethod.paymentMethod.paymentBank.accountHolder &&
        paymentMethod.paymentMethod.paymentBank.accountHolder.address &&
        paymentMethod.paymentMethod.paymentBank.accountHolder.address.postalCode &&
        paymentMethod.paymentMethod.paymentBank.accountHolder.address.country &&
        paymentMethod.paymentMethod.paymentBank.accountHolder.phone &&
        paymentMethod.paymentMethod.paymentBank.accountHolder.phone.countryCode &&
        paymentMethod.paymentMethod.paymentBank.accountHolder.phone.number
      ) {
        dispatch(
          createPayerConsolidatedOrPartialPayment(
            getTotalAmountToPay(),
            paymentMethod.paymentMethod.id,
            selectedMerchant,
            selectedMerchantInfo.defaultCurrency,
            true,
            {
              // honestly why are there two nearly-identical types for address and phone
              address: {
                line1: paymentMethod.paymentMethod.paymentBank.accountHolder.address.line1,
                line2: paymentMethod.paymentMethod.paymentBank.accountHolder.address.line2,
                city: paymentMethod.paymentMethod.paymentBank.accountHolder.address.city,
                region: paymentMethod.paymentMethod.paymentBank.accountHolder.address.region,
                postalCode: paymentMethod.paymentMethod.paymentBank.accountHolder.address.postalCode,
                country: paymentMethod.paymentMethod.paymentBank.accountHolder.address.country,
              },
              phone: {
                countryCode: paymentMethod.paymentMethod.paymentBank.accountHolder.phone.countryCode,
                number: paymentMethod.paymentMethod.paymentBank.accountHolder.phone.number,
              },
              lineItems: [],
            },
            paymentRequestAllocation,
            paymentRequestInfoList,
            getCreditMemoAmountToPay(),
            handlePaymentSent,
          ),
        );
        setSendingPayment(true);
      }
    }
  };

  const handleDeletePaymentMethod = () => {
    if (methodForEdit) {
      dispatch(deletePayerPaymentMethod(methodForEdit));
    } else if (defaultPaymentMethod) {
      dispatch(deletePayerPaymentMethod(defaultPaymentMethod));
    }

    if (confirmDeleteVisible === true) {
      toggleConfirmDelete();
    }
  };

  const submitVerification = (paymentMethodId: string | undefined, micro1: number, micro2: number) => {
    // Do verify of the bank account. Outcome of this determines toggling verification.
    dispatch(verifyBankPaymentMethod(paymentMethodId, [micro1, micro2]));
    toggleVerification();
  };
  const handleToggleRefundPolicyDisplay = () => {
    dispatch(fetchDisplayRefundPolicy(!displayRefundPolicy));
  };
  const submitPaymentWithSelectedMethod = () => {
    // Toggle confirm - since we aren't using credit, it will default to eCheck route on confirmation.
    dispatch(fetchPaymentMethodError());
    dispatch(fetchPaymentError());
    finalizePaymentSubmit();
  };
  const cancelPayment = (merchant?: string) => {
    if (window.location.pathname === '/make-payment') {
      dispatch(fetchPaymentRequestInfoList(undefined));
      dispatch(fetchConsolidatedOrPartialCancelClicked(true));
      if (payerTransactionSummaryByMerchant) {
        history.push('/payments');
      } else {
        history.push('/');
      }
    } else {
      setSelectedMerchant(undefined);
      if (merchant) {
        setSelectedMerchant(merchant);
      }
      history.push('/payments');
      dispatch(fetchHasSearchString(false));
      dispatch(clearPaymentRequestInfo());
      dispatch(fetchUrlToken(''));
    }
  };
  const createPaymentMethod = (
    type: PaymentMethodType,
    token: string,
    attachToResourceId: string | undefined,
    holder: PaymentMethodHolderInput,
    isDefault: boolean,
  ) => {
    dispatch(createPayerPaymentMethod(type, token, attachToResourceId, holder, isDefault, userEmail, toggleAddingPayments));
  };

  const hasActiveForm = verificationVisible || verifyInfoVisible;
  const editingOnMobile = isMobileSize && hasActiveForm;

  const selectPaymentMethodHandler = (payerPaymentMethod: PayerPaymentMethod) => {
    if (payerPaymentMethod) {
      dispatch(fetchSelectedPaymentMethod(payerPaymentMethod));
    }
  };
  const selectPaymentMethodForDeleteHandler = (payerPaymentMethod: PayerPaymentMethod) => {
    if (payerPaymentMethod) {
      dispatch(fetchPaymentMethodForEdit(payerPaymentMethod));
      toggleConfirmDelete();
    }
  };

  const handleVerificationOpen = (paymentMethod: PayerPaymentMethod) => {
    toggleVerification();
    setBankForVerification(paymentMethod);
  };

  const handleAddCardPaymentMethod = (isLoading?: boolean) => {
    setIsAddCardClicked(!isLoading);
    setAddPaymentMethodType(PaymentMethodType.CreditCard);
    toggleAddingPayments();
  };

  const handleAddBankPaymentMethod = () => {
    setIsAddBankClicked(true);
    setAddPaymentMethodType(PaymentMethodType.PaymentBankUs);
    toggleAddingPayments();
  };

  const handleAddPaymentMethodCancel = () => {
    if (isAddBankClicked) {
      setIsAddBankClicked(false);
    }

    if (isAddCardClicked) {
      setIsAddCardClicked(false);
    }
    if (isIFrameVisible) {
      setIsIFrameVisible(false);
    }

    toggleAddingPayments();
  };

  const handleSetSelectedPaymentMethod = (paymentMethod: PayerPaymentMethod | undefined) => {
    dispatch(fetchSelectedPaymentMethod(paymentMethod));
  };

  const isCreditCardAccepted = (
    paymentMethod: PayerPaymentMethod | undefined,
    acceptedPaymentMethods: AcceptedPaymentMethod[] | null | undefined,
  ): boolean => {
    const cardBrand = paymentMethod?.paymentMethod?.creditCard?.cardBrand;
    const acceptedPaymentMethod = cardBrand ? MapCardBrandToAcceptedPaymentMethod(cardBrand) : undefined;
    if (acceptedPaymentMethod && acceptedPaymentMethods && acceptedPaymentMethods?.indexOf(acceptedPaymentMethod) === -1) return false;
    return true;
  };

  const setSettingsMenuVisible = (isMenuVisible: boolean) => {
    dispatch(fetchMenuVisible(isMenuVisible));
  };

  const handleCreditMemoCardOpen = () => {
    dispatch(fetchCreditMemoDetailsOpen(true));
    if (selectedMerchantInfo?.owner?.tenantId && selectedMerchantInfo.owner.tenantId.length > 0) {
      dispatch(fetchOpenCreditMemos(undefined, pageSize, selectedMerchantInfo.owner.tenantId));
      dispatch(fetchCreditMemosHistory(undefined, pageSize, selectedMerchantInfo.owner.tenantId));
    }
  };

  const handleCreditMemoCardClose = () => {
    dispatch(fetchCreditMemoDetailsOpen(false));
    dispatch(clearOpenCreditMemoConnection());
    dispatch(clearOpenCreditMemos());
    dispatch(clearCreditMemoHistory());
    dispatch(clearCreditMemoHistoryConnection());
  };

  const loadOpenCreditMemosPage = (tenantId?: string, endCursor?: string) => {
    if (tenantId && tenantId.length > 0) {
      dispatch(fetchOpenCreditMemos(endCursor, pageSize, tenantId));
    }
  };

  const loadCreditMemoHistoryPage = (tenantId?: string, endCursor?: string) => {
    if (tenantId && tenantId.length > 0) {
      dispatch(fetchCreditMemosHistory(endCursor, pageSize, tenantId));
    }
  };

  const getCreditMemoBalance = (tenantId?: string) => {
    if (tenantId && tenantId.length > 0) {
      dispatch(fetchCreditMemoBalance(tenantId));
    }
  };

  const setSelectedMerchantInfo = (tenantId?: string) => {
    if (tenantId && tenantId.length > 0 && payerTransactionSummaryByMerchant?.merchantSummary) {
      const merchantInfo = payerTransactionSummaryByMerchant?.merchantSummary.find(merchant => {
        return tenantId === merchant.merchantInfo?.owner?.tenantId;
      })?.merchantInfo;
      dispatch(fetchSelectedMerchantInfo(merchantInfo as MerchantInfo));
    }
  };

  const paymentMethodsListNew = (
    <PaymentMethods
      deleteMethod={selectPaymentMethodForDeleteHandler}
      paymentMethods={sortedPaymentMethods}
      setAsDefault={setDefaultMethod}
      deletePaymentMethodError={deletePaymentMethodError}
      handleVerifyClick={handleVerificationOpen}
      handleAddCard={handleAddCardPaymentMethod}
      handleAddBank={handleAddBankPaymentMethod}
      handleSelectPaymentMethod={selectPaymentMethodHandler}
      forSelect={false}
    />
  );

  const handleAddBillingAddress = (billingAddress: PaymentMethodHolder) => {
    dispatch(addBillingAddress(billingAddress));
  };
  const paymentMethodAdd = (
    <PaymentMethodAdd
      isReplace={false}
      submit={createPaymentMethod}
      continueText={'Add'}
      cancel={handleAddPaymentMethodCancel}
      onMobile={editingOnMobile}
      viewerUser={viewerUser}
      paymentMethods={paymentMethods}
      payerProfileHolderInfo={
        defaultPaymentMethod?.paymentMethod?.creditCard
          ? defaultPaymentMethod.paymentMethod.creditCard.cardHolder
          : defaultPaymentMethod?.paymentMethod?.paymentBank?.accountHolder
      }
      addPaymentMethodType={addPaymentMethodType}
      billingAddresses={billingAddresses}
      addBillingAddress={handleAddBillingAddress}
      paymentMethodAddStep={paymentMethodAddStep}
      setPaymentMethodAddStep={setPaymentMethodAddStep}
      isIFrameVisible={isIFrameVisible}
      setIsIFrameVisible={setIsIFrameVisible}
      loadingPaymentMethods={loadingPaymentMethods}
      addPaymentMethodError={paymentMethodError}
    />
  );

  const paymentMethodVerification = (
    <PaymentMethodVerification
      handleBack={toggleVerification}
      onMobile={editingOnMobile}
      submit={submitVerification}
      merchantStatementDescription={'WePay'}
      paymentMethod={bankForVerification}
    />
  );
  const payPaymentRequest = (
    <PayPaymentRequest
      merchantInfo={selectedMerchantInfo}
      displayRefundPolicy={displayRefundPolicy}
      paymentRequestInfo={paymentRequestInfo}
      toggleRefundPolicyDisplay={handleToggleRefundPolicyDisplay}
      hasPaymentMethods={!!(paymentMethods && paymentMethods.length > 0)}
      changePaymentMethod={handleSetSelectedPaymentMethod}
      allowCreditCard={(!!paymentRequestInfo && requestPayable && cardAllowed) || (!!paymentRequestInfoList && cardAllowed)}
      allowECheck={eCheckAllowed && (!paymentRequestInfo || paymentRequestInfo.currency === CurrencyType.Usd)}
      paymentMethod={selectedPaymentMethod}
      defaultPaymentMethod={defaultPaymentMethod}
      submitPayment={submitPaymentWithSelectedMethod}
      paymentMethods={paymentMethods}
      sortedPaymentMethods={sortedPaymentMethods}
      billingAddresses={billingAddresses}
      viewerUser={viewerUser}
      handleAddCard={handleAddCardPaymentMethod}
      handleAddBank={handleAddBankPaymentMethod}
      paymentError={paymentError}
      isCreditCardAccepted={isCreditCardAccepted}
      loading={networkBusy}
      paymentAddVisible={paymentAddVisible}
      paymentMethodAdded={paymentMethodAdded}
      cancelPayment={cancelPayment}
      paymentRequestInfoList={paymentRequestInfoList}
      isMobileView={isMobileSize}
      getPaymentRequestInfoAmount={getPaymentRequestInfoAmount}
      creditMemoBalance={creditMemoBalance}
      creditMemoBalanceError={creditMemoBalanceError}
      loadingCreditMemoBalance={loadingCreditMemoBalance}
      fetchCreditMemoBalance={getCreditMemoBalance}
      setMerchantInfo={setSelectedMerchantInfo}
      useCreditMemo={useCreditMemo}
      setUseCreditMemo={setUseCreditMemo}
      sendingPayment={sendingPayment}
      handleCreditMemoCardClose={handleCreditMemoCardClose}
    />
  );

  const getPaymentRequestHeader = (paymentRequestInfo: PaymentRequestInfo | undefined): JSX.Element | undefined => {
    if (!paymentRequestInfo) {
      return <PaymentInfoNotFound />;
    }
    if (paymentRequestInfo) {
      if (!paymentRequestInfo.refundPolicy) {
        return <MissingRefundPolicy />;
      }
      if (paymentRequestInfo.status === PaymentRequestStatus.Completed) {
        return <PaymentReceived />;
      }
      if (paymentRequestInfo.status === PaymentRequestStatus.Unknown) {
        const paymentMethod = selectedPaymentMethod || defaultPaymentMethod;
        const email =
          paymentMethod?.paymentMethod?.creditCard?.cardHolder?.email ||
          paymentMethod?.paymentMethod?.paymentBank?.accountHolder?.email;
        return <PaymentUnknown email={email} />;
      }
      if (!requestPayable) {
        // Catch for status's which will not allow a payment to be processed for this request.
        // TODO: What should unknown be handled as?
        return <PaymentProcessing status={paymentRequestInfo.status} />;
      }
    }
    return undefined;
  };

  //The user is paying a payment request
  const getPaymentView = () => {
    if ((paymentRequestInfoList && paymentRequestInfoList.length > 0) || (!paymentRequestInfoList && !paymentRequestInfo)) {
      return (
        <Grid item container justify="center" xs={12} sm={settingsMenuVisible ? 6 : 12} md={4} className={classes.transition}>
          {payPaymentRequest}
        </Grid>
      );
    }
    const paymentHeader = getPaymentRequestHeader(paymentRequestInfo);
    if (paymentHeader) {
      return (
        <Grid item xs={8} md={4}>
          <Paper>{paymentHeader}</Paper>
        </Grid>
      );
    }

    return (
      <Grid item container justify="center" xs={12} sm={settingsMenuVisible ? 6 : 12} md={4} className={classes.transition}>
        {payPaymentRequest}
      </Grid>
    );
  };

  //The user is not paying a payment request
  const getHomeView = () => {
    return (
      <Box className={classes.transition} style={{ width: settingsMenuVisible && !matchesXsDown ? 'calc(100% - 372px)' : '100%' }}>
        <Grid item container xs={12} justify="center" style={{ display: 'flex' }}>
          <Switch>
            <Route path="/payments">
              <MerchantRequestsView />
            </Route>
            <Route path="/make-payment">{getPaymentView()}</Route>
            <Route path="/">
              <MerchantSummaryView merchantSortAnchorEl={merchantSortAnchorEl} />
            </Route>
          </Switch>
        </Grid>
      </Box>
    );
  };

  return (
    <>
      {/* {Loading Mask} */}
      <LoadingMask loading={isAddCardClicked === true && isIFrameVisible === false} />
      {/* {Dialogs} */}
      <Dialog
        open={paymentAddVisible}
        maxWidth={paymentMethodAddStep === 0 ? 'xs' : 'sm'}
        className={isIFrameVisible === false && isAddBankClicked === false ? classes.noneDisplay : ''}
      >
        {paymentMethodAdd}
      </Dialog>
      <Dialog open={confirmDeleteVisible} maxWidth="sm">
        <DialogContent>
          <ConfirmDelete handleCancel={toggleConfirmDelete} handleDelete={handleDeletePaymentMethod} />
        </DialogContent>
      </Dialog>
      <Dialog open={verificationVisible} maxWidth="xs">
        <DialogContent>{paymentMethodVerification}</DialogContent>
      </Dialog>
      <CreditMemosDetails
        open={creditMemoDetailsOpen}
        close={handleCreditMemoCardClose}
        merchantInfo={selectedMerchantInfo}
        openCreditMemoConnection={openCreditMemoConnection}
        openCreditMemos={openCreditMemos}
        openCreditMemosError={openCreditMemosError}
        loadOpenCreditMemosPage={loadOpenCreditMemosPage}
        creditMemoHistoryConnection={creditMemoHistoryConnection}
        creditMemoHistory={creditMemoHistory}
        creditMemoHistoryError={creditMemoHistoryError}
        loadCreditMemoHistoryPage={loadCreditMemoHistoryPage}
      />

      {/* {Main Content} */}
      <Grid
        container
        xs={12}
        justify={!hasSearchString || (hasSearchString && isMobileSize) ? 'flex-end' : 'center'}
        className={isMobileSize ? classes.mobileHomeView : classes.homeView}
      >
        {hasSearchString ? getPaymentView() : getHomeView()}
      </Grid>

      {/* {Drawer / hamburger menu} */}
      <SettingsMenu
        viewerUser={viewerUser}
        paymentMethodsListView={paymentMethodsListNew}
        isMenuOpen={settingsMenuVisible}
        setIsMenuOpen={setSettingsMenuVisible}
        creditBalance={creditMemoBalance}
        creditMemoCardClick={handleCreditMemoCardOpen}
        loadingCreditBalance={loadingCreditMemoBalance}
        merchantInfo={selectedMerchantInfo}
        creditBalanceError={creditMemoBalanceError}
        deletingPaymentMethod={deletingPaymentMethod}
      />
    </>
  );
};

export default MultipleMethodsHome;
